import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getWelcomMessage, sendMessage } from "./ChatBotApi";
import { ChatBotState } from "../../../features/view/public/Chatbot/ChatBotTypes";

const initialState: ChatBotState = {
  chat: {
    data: {},
    loader: false,
  },
};

export const getWelcomMessageAsync = createAsyncThunk(
  "chat/api/chatbot-data/",
  async (payload: any) => {
    const response = await getWelcomMessage(payload);
    return response;
  }
);

export const sendMessageAsync = createAsyncThunk(
  "chat/user_query/",
  async (payload: any) => {
    const response = await sendMessage(payload);
    return response;
  }
);

export const ChatBotSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getWelcomMessageAsync.pending, (state) => {
        state.chat.loader = true;
      })
      .addCase(getWelcomMessageAsync.fulfilled, (state, action: any) => {
        state.chat.loader = false;
        state.chat.data = action?.payload?.data?.data || [];
      })
      .addCase(getWelcomMessageAsync.rejected, (state) => {
        state.chat.loader = false;
      })
      .addCase(sendMessageAsync.pending, (state) => {
        state.chat.loader = true;
      })
      .addCase(sendMessageAsync.fulfilled, (state, action: any) => {
        state.chat.loader = false;
        state.chat.data = action?.payload?.data?.data || [];
      })
      .addCase(sendMessageAsync.rejected, (state) => {
        state.chat.loader = false;
      });
  },
});

export default ChatBotSlice.reducer;
